import axios from 'axios';
import Config from '@/config';

const baseUrl = `${Config.firebaseFunctionsBaseUrl}`;

export default {
  queryMixpanel: async function(params, script) {
    const url = `${baseUrl}/queryMixpanel`;

    const headers = {
      'Content-Type': 'application/json'
    };

    const body = {
      params: params,
      script: script
    };

    const result = await axios.post(url, body, { headers });
    return result;
  }
};
